import React, { useMemo, useState, useCallback, useEffect, useRef } from "react";
import { Button } from "react-bootstrap";
import Dropdown from "react-bootstrap/Dropdown";
import search from "../../../assets/Vehicles/search.png";
import { Plus, ChevronLeft, ChevronRight } from "lucide-react";
import close from "../../../assets/Vehicles/close_filter.png";
import fill_chevron_down from "../../../assets/Vehicles/fill_chevron_down.png";
import customize from "../../../assets/Vehicles/customize.png";
import down from "../../../../src/assets/Vehicles/chevron_down.png";
import Offcanvas from "react-bootstrap/Offcanvas";
import edit from "../../../assets/Asssignment/edit.png";
import trash from "../../../assets/Asssignment/delete.png";
import closeoff from "../../../assets/Asssignment/close.png";
import { useReactTable, getCoreRowModel, getSortedRowModel, getFilteredRowModel, getPaginationRowModel, flexRender } from "@tanstack/react-table";

import { Columns } from "../../Vehicles/Column.js";
import MOCK_DATA from "../../Vehicles/MOCK_DATA.json";
import "../../Vehicles/Vehicle_list/List.css";
import { useNavigate } from "react-router-dom";
import { getServiceReminderListApi } from "../services-api.js";
import ReactPaginate from "react-paginate";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import lar from "../../../assets/svg/lar.svg";
import rar from "../../../assets/svg/rar.svg";
import editIcon from "../../../assets/svg/edit.svg";
import delIcon from "../../../assets/svg/delete.svg";
import DeleteModal from "../../common/delete-modal.js";
import { Toast, ToastContainer } from "react-bootstrap";
import { AddReminder } from "./AddReminder.jsx";
import { ViewReminder } from "./ViewReminder.jsx";
import CommonDropdown from "../../common/common_dropDown";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import { useGlobal } from "../../../GlobalContext.js";

export const ServiceReminder = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const { rolePermissionList, userType } = useGlobal();

  const isFirstRender = useRef(true);

  const [activeTab, setActiveTab] = useState("service");

  const tabButtons = [
    { key: "service", label: "Service expenses" },
    { key: "fuel", label: "Fuel expenses" },
    { key: "other", label: "Other expenses" },
  ];

  const serviceExpense = [
    { label: "Safety system service", value: "₹35,000" },
    { label: "Water wash", value: "₹500" },
    { label: "Engine oil check", value: "₹230" },
  ];
  const fuelExpense = [
    { label: "Petrol", value: "₹2,000" },
    { label: "Diesel", value: "₹3,000" },
    { label: "CNG", value: "₹1,500" },
  ];
  const otherExpense = [
    { label: "Parking", value: "₹200" },
    { label: "Toll", value: "₹500" },
    { label: "Accessories", value: "₹1,200" },
  ];

  const [show, setShow] = useState(false);
  const [editId, setEditId] = useState(null);

  useEffect(() => {
    if (editId != null) {
      console.log("edit called");
      handleShow();
    }
  }, [editId]);

  const handleShow = () => setShow(true);

  const handleClose = (response) => {
    if (!response || !response.data) {
      setShow(false);
      setEditId(null);
    } else {
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      setShow(false);
      setEditId(null);
    }
    getServiceReminderList();
  };

  const getExpenseData = () => {
    if (activeTab === "service") return serviceExpense;
    if (activeTab === "fuel") return fuelExpense;
    return otherExpense;
  };
  const columns = [
    {
      header: "Service ID",
      accessorKey: "service_id",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "VIN",
      accessorKey: "vin",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },
    {
      header: "Service Reminder",
      accessorKey: "service_name",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Due Date",
      accessorKey: "due_date",
      cell: (info) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "150px",
          }}
        >
          {info.getValue()}
        </div>
      ),
    },

    {
      header: "Status",
      accessorKey: "status",
      cell: (info) => {
        console.log(info);
        return (
          <div
            className="hover-action-cell"
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "150px",
            }}
          >
            <span>{info.getValue()}</span>
            <div className="click-actions">
              {checkPermission("Service Reminders", "edit_permission") && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation(); // prevent triggering row click
                    /*  handleEdit(info.row.id); */
                    setEditId(info.row.original.id);
                  }}
                >
                  <img src={editIcon} alt="edit" />
                </button>
              )}
              {checkPermission("Service Reminders", "delete_permission") && (
                <button
                  className="icon-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeleteId(info.row.original.id);
                  }}
                >
                  <img src={delIcon} alt="delete" />
                </button>
              )}
            </div>
          </div>
        );
      },
    },
  ];
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex((element) => element["name"] === menuName && element["menu_permission"] === true && element[permission] === true) > -1 ? true : false;
  }
  const data = useMemo(() => MOCK_DATA, []);
  const navigate = useNavigate();

  // Define sortByList before using it in useState
  const sortByList = [
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];

  const statusList = [
    { value: "", label: "All" },
    { value: "Open", label: "Open" },
    { value: "Closed", label: "Closed" },
    { value: "Expired", label: "Expired" },
  ];

  // Global filter (search)
  const [globalFilter, setGlobalFilter] = useState("");
  const [sortByValue, setSortByValue] = useState(sortByList[1]);
  const [sortByField, setSortByField] = useState("created");
  const [sortByDir, setSortByDir] = useState("desc");

  const [serviceOption, setServiceOption] = useState(null);
  const [statusOption, setStatusOption] = useState(null);
  const [selectedDate, setSelectedDate] = useState();
  const handleSelectService = (item) => {
    setServiceOption(item);
  };

  const [serviceReminderList, setServiceReminderList] = useState([]);
  const [listCount, setListCount] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  useEffect(() => {
    getServiceReminderList();
  }, [itemsPerPage, itemOffset, globalFilter, serviceOption, statusOption, selectedDate, sortByField, sortByDir]);
  const getServiceReminderList = async () => {
    try {
      const response = await getServiceReminderListApi(`search=${globalFilter}&limit=${itemsPerPage}&skip=${itemOffset * itemsPerPage}&service_id=${serviceOption != null ? serviceOption.value : ""}&status=${statusOption != null ? statusOption.value : ""}&date=${selectedDate != null && selectedDate !== "" ? selectedDate.toLocaleDateString("en-CA") : ""}&sort_field=${sortByField}&sort_dir=${sortByDir}`);
      if (response.data.success === true) {
        setListCount(response.data.total_rec);
        setServiceReminderList(response.data.reminders);
        setPageCount(response.data.total_pgs);
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const handlePageClick = useCallback((event) => {
    const newOffset = (event.selected * itemsPerPage) % serviceReminderList.length;
    console.log(`User requested page number ${event.selected}, which is offset ${newOffset}`);
    setItemOffset(event.selected);
  }, []);

  const table = useReactTable({
    data: serviceReminderList ?? [],
    columns,
    state: {
      globalFilter,
    },
    onGlobalFilterChange: setGlobalFilter,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
  });
  const { pageIndex, pageSize } = table.getState().pagination;
  const pageOptions = table.getPageOptions();

  const [showRowOffcanvas, setShowRowOffcanvas] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);

  const handleCloseRowOffcanvas = () => setShowRowOffcanvas(false);

  const handleRowClick = (rowData) => {
    console.log("rowData........" + rowData);
    setSelectedRowData(rowData);
  };
  useEffect(() => {
    console.log(selectedRowData);
    if (selectedRowData != null) {
      setShowRowOffcanvas(true);
    }
  }, [selectedRowData]);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);

  const [deleteId, setDeleteId] = useState(null);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  useEffect(() => {
    if (deleteId != null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);

  const cancelDelete = () => {
    setDeleteId(null);
    setIsOpenDelete(false);
  };
  const onSuccessDelete = (response) => {
    setDeleteId(null);
    setSnackbarMessage(response.message);
    setSnackbarStatus(response.success);
    handleSnackbarShow();
    if (response.success === true) {
      setIsOpenDelete(false);
      getServiceReminderList();
    }
  };
  const editReminder = (id) => {
    setShowRowOffcanvas(false);
    setEditId(id);
  };

  const [hoveredRow, setHoveredRow] = useState(null);
  return (
    <>
      {isOpenDelete && <DeleteModal deleteUrl={`service_reminder/delete/${deleteId}`} onSuccess={onSuccessDelete} onCancel={cancelDelete} />}
      {showRowOffcanvas && <ViewReminder id={selectedRowData?.id} editReminder={editReminder} show={showRowOffcanvas} handleClose={handleCloseRowOffcanvas} />}
      <div className="bg-half-white">
        <div className=" rounded-4" style={{ background: "#FFFFFF", margin: "16px" }}>
          <div className="d-flex p-3 flex-wrap align-items-center justify-content-between">
            <div className="d-flex flex-column">
              <p className="bg-transparent fw-bold dark-purple border-0 fs-24 assigned-dropdowns m-0">Service Reminder</p>
              <p className="text-muted">{listCount} records</p>
            </div>
            <div className="d-flex flex-wrap gap-3">
              <div className="search-wrapper d-flex align-items-center gap-2 bg-white rounded-3 px-3 py-2">
                <img src={search} alt="search" />
                <input type="text" placeholder="Search" className="border-0 outline-0 rounded-3" value={globalFilter || ""} onChange={(e) => setGlobalFilter(e.target.value)} />
              </div>
              {checkPermission("Service Reminders", "create_permission") && (
                <Button className="dark-purple-btn border-0 d-flex gap-1 px-3 rounded-3 text-white" onClick={handleShow}>
                  <Plus />
                  Add new
                </Button>
              )}
              <AddReminder id={editId} show={show} handleClose={handleClose} onSuccess={handleClose} />
            </div>
          </div>

          {/* Filters */}
          <div className="d-flex flex-wrap align-items-center justify-content-between p-3 gap-2">
            <div className="d-flex flex-wrap align-items-center gap-3">
              <p className="m-0 text-filter-grey fw-semibold">Filter :</p>
              <Dropdown data-tooltip-id="sort-tooltip" data-tooltip-content="Sort by">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {sortByValue?.label}
                  <img src={fill_chevron_down} alt="chev down" />
                </Dropdown.Toggle>

                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {sortByList.map((item, index) => (
                    <Dropdown.Item
                      key={index}
                      onClick={() => {
                        const [field, dir] = item.value.split(" ");
                        setSortByField(field);
                        setSortByDir(dir);
                        setSortByValue(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>

                <Tooltip id="sort-tooltip" place="top" />
              </Dropdown>
              <div className="w-15 w-md-25 w-lg-18 d-flex" style={{ maxWidth: "160px" }} data-tooltip-id="service-tooltip" data-tooltip-content="Service">
                <CommonDropdown apiUrl={`${apiUrl}get_services`} placeholder="Service" value={serviceOption} onSelect={handleSelectService} searchView={true} />

                <Tooltip id="service-tooltip" place="top" />
              </div>
              <Dropdown data-tooltip-id="status-tooltip" data-tooltip-content="Status">
                <Dropdown.Toggle id="dropdown-basic" className="bg-white text-purple search-border assigned-dropdown rounded-4 px-4 d-flex align-items-center gap-2">
                  {statusOption != null ? statusOption.label : "Status"} <img src={fill_chevron_down} alt="chev down" />
                  {statusOption != null && <img onClick={() => setStatusOption(null)} src={close} alt="x" />}
                </Dropdown.Toggle>
                <Dropdown.Menu style={{ minWidth: "unset", width: "100%" }}>
                  {statusList.map((item) => (
                    <Dropdown.Item
                      onClick={() => {
                        setStatusOption(item);
                      }}
                    >
                      {item.label}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
                <Tooltip id="status-tooltip" place="top" />
              </Dropdown>
              <div className="w-15 w-md-25 w-lg-18 d-flex align-items-center bg-white text-purple search-border rounded-4" style={{ maxWidth: "180px" }} data-tooltip-id="date-tooltip" data-tooltip-content="Date">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  dateFormat="dd-mm-yyyy"
                  customInput={
                    <button style={{ color: "#8790A1" }} className="border-0 form-control vehicle-form-input bg-white rounded-4 px-3 py-2 d-flex justify-content-between align-items-center gap-2">
                      {selectedDate ? selectedDate.toLocaleDateString("en-GB").replace(/\//g, "-") : <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>}
                      <Calendar size={16} />
                    </button>
                  }
                />
                <Tooltip id="date-tooltip" place="top" />
                {selectedDate != null && <img onClick={() => setSelectedDate(null)} src={close} alt="x" style={{ height: "30px" }} />}
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="p-3">
            <div className="table-wrapper overflow-x-auto">
              <table>
                <thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                    <tr key={headerGroup.id}>
                      {headerGroup.headers.map((header) => (
                        <th key={header.id} className="px-3 py-2" onClick={header.column.getToggleSortingHandler()}>
                          {flexRender(header.column.columnDef.header, header.getContext())}
                          {header.column.getIsSorted() === "asc" && " asc"}
                          {header.column.getIsSorted() === "desc" && " des"}
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody>
                  {table.getRowModel().rows.map((row, index) => (
                    <tr
                      key={row.id}
                      style={{
                        position: "relative",
                        backgroundColor: hoveredRow === index ? "#F9F2FF" : "#ffffff",
                        cursor: "pointer",
                        transition: "border-color 0.3s",
                        borderLeft: hoveredRow === index ? "3px solid #471070" : "3px solid #E5E5E5",
                      }}
                      onMouseEnter={() => setHoveredRow(index)}
                      onMouseLeave={() => setHoveredRow(null)}
                      onClick={() => handleRowClick(row.original)}
                    >
                      {row.getVisibleCells().map((cell) => (
                        <td key={cell.id} className="px-3 py-2">
                          {flexRender(cell.column.columnDef.cell, cell.getContext())}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">Records per page: &nbsp;</span>
                <Dropdown.Toggle id="dropdown-basic" className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0">
                  <span className="bg-white no-of-rows rounded-3 px-2 py-2">
                    {itemsPerPage} <img src={down} alt="" />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu className="my-2" style={{ minWidth: "unset", width: "30%" }}>
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        table.setPageSize(size);
                        setItemsPerPage(size);
                        setItemOffset(0);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate previousLabel={<img src={lar} className="ar3" alt="previous" />} nextLabel={<img src={rar} className="ar3" alt="next" />} breakLabel={"..."} pageCount={pageCount + 1} marginPagesDisplayed={2} pageRangeDisplayed={3} onPageChange={handlePageClick} containerClassName={"pagination"} activeClassName={"active"} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
